import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { Layer } from 'bernie-view';
import { LocalizedComponentProps, LocalizedText } from 'bernie-l10n';
import { QueryRoute, RouteStore } from 'bernie-core';

import { SearchResultsStore } from 'stores/search-results-store';

import { UitkCard, UitkCardContent, UitkCardLink, UitkCardMedia, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkSecondaryButton } from 'uitk-react-button';

import { SearchResultsMap } from 'components/search/map';

const LinkTracked = ClickTracker(Link);
const ButtonTracked = ClickTracker(UitkSecondaryButton);

export interface MapToggleProps extends LocalizedComponentProps {
  className?: string;
  routeStore?: RouteStore;
  searchResults?: SearchResultsStore;
  layerManager?: RouteStore;
  mapImage?: string;
  isActive: boolean;
}

@inject('searchResults', 'layerManager', 'routeStore')
@observer
export class MapToggle extends React.Component<MapToggleProps> {
  private mapBtn;

  constructor(props) {
    super(props);

    this.onMapDialogClosed = this.onMapDialogClosed.bind(this);
    this.mapBtn = React.createRef();
  }

  public static defaultProps = {
    isActive: false
  };

  public render() {
    const { isActive, searchResults, routeStore, mapImage } = this.props;
    const { isLoading, isError, isEmpty } = searchResults;
    const map = searchResults && searchResults.map;
    const mapOpenQuery = routeStore.mergeQueryString(routeStore.search, { pwaOverlay: 'map' });
    const linkTo = {
      pathname: routeStore.pathname,
      search: mapOpenQuery
    };
    const extraProps =
      isActive && map && Object.keys(map).length > 0
        ? {
            tag: Link,
            to: linkTo
          }
        : {};

    const triggerRef = mapBtn => {
      this.mapBtn = mapBtn;
    };

    return (
      <React.Fragment>
        <QueryRoute query={{ pwaOverlay: 'map' }}>
          <Layer id="tools-map">
            <SearchResultsMap onDismiss={this.onMapDialogClosed} />
          </Layer>
        </QueryRoute>
        {mapImage && (
          <UitkCard imageType="header">
            <UitkCardMedia>
              <UitkFigure ratio={UitkFigureAspectRatioType.R21_9}>
                <UitkImage alt="" src={mapImage} className="uitk-rounded-border-top" />
              </UitkFigure>
            </UitkCardMedia>
            <UitkCardContent>
              <UitkCardTextSegment className="uitk-type-300 uitk-type-center uitk-button-old-link">
                <span aria-hidden="true">
                  <LocalizedText message="hotels.searchResults.openMapDialog.label" />
                </span>
              </UitkCardTextSegment>
              <UitkCardLink>
                <LinkTracked linkName="Launch dynamic map" rfrr="Module.MapOpen.Link" to={linkTo} innerRef={triggerRef}>
                  <LocalizedText message="hotels.searchResults.openMapDialog.label" />
                </LinkTracked>
              </UitkCardLink>
            </UitkCardContent>
          </UitkCard>
        )}
        {!mapImage && (
          <ButtonTracked
            data-stid="open-dynamic-map"
            disabled={!isActive || isLoading || isError || isEmpty || null}
            linkName="Launch dynamic map"
            rfrr="Module.MapOpen.Link"
            icon="map"
            text={<LocalizedText message="hotels.searchResults.openMapDialog.label" />}
            isFullWidth={true}
            {...extraProps}
          />
        )}
      </React.Fragment>
    );
  }

  private onMapDialogClosed(): void {
    this.props.routeStore.updateSearch({
      pwaOverlay: undefined
    });

    if (this.mapBtn && typeof this.mapBtn.focus === 'function') {
      this.mapBtn.focus();
    }
  }
}
